/* eslint-disable no-throw-literal */
import apiClient from './apiClient.js';

export const getSpecialRules = () => apiClient.get('/special-rules');
export const getSpecialRuleById = (id) => apiClient.get(`/special-rules/${id}`);
export const getSpecialRulesAll = () => apiClient.get('/special-rules/all');
export const getSpecialRuleAllById = (id) => apiClient.get(`/special-rules/all/${id}`);
export const getSpecialRulesByDomainId = (domainId) => apiClient.get(`/special-rules/domain/${domainId}`);
export const getMatchingUsersBySpecialRuleId = (id) => apiClient.get(`/special-rules/${id}/matching-users`);

export const evaluateTestSpecialRule = async (data) => {
  try {
    const response = await apiClient.post('/special-rules/evaluate-test', data);
    return response.data;
  } catch (error) {
    if (error.response) {
      throw { type: 'general', message: error.response.data?.error || 'Ha ocurrido un error al evaluar la regla.' };
    }
    throw { type: 'general', message: 'Error de conexión, por favor intente nuevamente.' };
  }
};

export const createSpecialRule = async (data) => {
  try {
    const response = await apiClient.post('/special-rules', data);
    return response.data;
  } catch (error) {
    if (error.response) {
      if (error.response.status === 409) {
          throw { type: 'duplicate', message: error.response.data?.error || 'La regla ya existe.' };
      }
      throw { type: 'general', message: error.response.data?.error || 'Ha ocurrido un error, por favor intente nuevamente.' };
    }
    throw { type: 'general', message: 'Error de conexión, por favor intente nuevamente.' };
  }
};

export const updateSpecialRule = (id, data) => apiClient.put(`/special-rules/${id}`, data);
export const deleteSpecialRule = (id) => apiClient.delete(`/special-rules/${id}`);
export const deleteSpecialRuleHard = (id) => apiClient.delete(`/special-rules/all/${id}`);
export const applySpecialRule = async (id) => {
  try {
    const response = await apiClient.post(`/special-rules/${id}/apply`);
    return response.data;
  } catch (error) {
    if (error.response) {
      throw { type: 'general', message: error.response.data?.error || 'Ha ocurrido un error al aplicar la regla.' };
    }
    throw { type: 'general', message: 'Error de conexión, por favor intente nuevamente.' };
  }
};
